/**
 * Section 8: Property Valuation - Property Condition
 */
/* eslint-disable react/jsx-no-bind */

import { useForm } from '@ox/visits-ui/context/FormContext';
import { Input, Select, Textarea } from '@ox/visits-ui/components/shared/FormComponents';

export function Section8PropertyDetails() {
  const { formData, updateField } = useForm();

  return (
    <div className="form-section">
      <h2>Property Valuation - Property Condition</h2>
      <p>
        Please fill out these questions to the best of your ability given what you encountered at
        the property.
      </p>

      <Select
        label="Appliance Finishes"
        name="appliance_finishes"
        value={formData.appliance_finishes || ''}
        onChange={(value) => updateField('appliance_finishes', value)}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'White', value: 'White' },
          { label: 'Stainless Steel', value: 'Stainless Steel' },
          { label: 'Black', value: 'Black' },
          { label: 'Mixed Finishes', value: 'Mixed Finishes' },
          { label: 'Missing', value: 'Missing' },
        ]}
        required
      />

      <Select
        label="Kitchen Counter Finish"
        name="kitchen_counter_finish"
        value={
          formData.kitchen_counter_finish?.startsWith('Other:')
            ? 'Other'
            : formData.kitchen_counter_finish || ''
        }
        onChange={(value) => {
          if (value === 'Other') {
            updateField('kitchen_counter_finish', 'Other: ');
          } else {
            updateField('kitchen_counter_finish', value);
          }
        }}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Granite', value: 'Granite' },
          { label: 'Quartz', value: 'Quartz' },
          { label: 'Formica', value: 'Formica' },
          { label: 'Other', value: 'Other' },
        ]}
        required
      />
      {formData.kitchen_counter_finish?.startsWith('Other:') && (
        <Input
          label="Specify counter finish"
          name="kitchen_counter_finish_other"
          value={formData.kitchen_counter_finish.replace('Other: ', '')}
          onChange={(value) => updateField('kitchen_counter_finish', 'Other: ' + value)}
          placeholder="Please specify..."
        />
      )}

      <Select
        label="Primary Flooring Type"
        name="primary_flooring_type"
        value={
          formData.primary_flooring_type?.startsWith('Other:')
            ? 'Other'
            : formData.primary_flooring_type || ''
        }
        onChange={(value) => {
          if (value === 'Other') {
            updateField('primary_flooring_type', 'Other: ');
          } else {
            updateField('primary_flooring_type', value);
          }
        }}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Carpet', value: 'Carpet' },
          { label: 'Hardwood', value: 'Hardwood' },
          { label: 'Laminate', value: 'Laminate' },
          { label: 'Tile', value: 'Tile' },
          { label: 'Other', value: 'Other' },
        ]}
        required
      />
      {formData.primary_flooring_type?.startsWith('Other:') && (
        <Input
          label="Specify primary flooring"
          name="primary_flooring_type_other"
          value={formData.primary_flooring_type.replace('Other: ', '')}
          onChange={(value) => updateField('primary_flooring_type', 'Other: ' + value)}
          placeholder="Please specify..."
        />
      )}

      <Select
        label="Secondary Flooring Type"
        name="secondary_flooring_type"
        value={
          formData.secondary_flooring_type?.startsWith('Other:')
            ? 'Other'
            : formData.secondary_flooring_type || ''
        }
        onChange={(value) => {
          if (value === 'Other') {
            updateField('secondary_flooring_type', 'Other: ');
          } else {
            updateField('secondary_flooring_type', value);
          }
        }}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Carpet', value: 'Carpet' },
          { label: 'Hardwood', value: 'Hardwood' },
          { label: 'Laminate', value: 'Laminate' },
          { label: 'Tile', value: 'Tile' },
          { label: 'Other', value: 'Other' },
        ]}
      />
      {formData.secondary_flooring_type?.startsWith('Other:') && (
        <Input
          label="Specify secondary flooring"
          name="secondary_flooring_type_other"
          value={formData.secondary_flooring_type.replace('Other: ', '')}
          onChange={(value) => updateField('secondary_flooring_type', 'Other: ' + value)}
          placeholder="Please specify..."
        />
      )}

      <Select
        label="Overall Interior Condition?"
        name="overall_interior_condition"
        value={formData.overall_interior_condition || ''}
        onChange={(value) => updateField('overall_interior_condition', parseInt(value))}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: '1 - Bad', value: '1' },
          { label: '2 - Fair', value: '2' },
          { label: '3 - Good', value: '3' },
          { label: '4 - Excellent', value: '4' },
        ]}
        required
      />

      <Select
        label="Overall Exterior Condition?"
        name="overall_exterior_condition"
        value={formData.overall_exterior_condition || ''}
        onChange={(value) => updateField('overall_exterior_condition', parseInt(value))}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: '1 - Bad', value: '1' },
          { label: '2 - Fair', value: '2' },
          { label: '3 - Good', value: '3' },
          { label: '4 - Excellent', value: '4' },
        ]}
        required
      />

      <Select
        label="If attached garage is it functional?"
        name="attached_garage_functional"
        value={formData.attached_garage_functional || ''}
        onChange={(value) => updateField('attached_garage_functional', parseInt(value))}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Yes', value: '1' },
          { label: 'No', value: '2' },
        ]}
        required
      />

      <Select
        label="Close to busy road/double yellow lines?"
        name="close_to_busy_road"
        value={formData.close_to_busy_road || ''}
        onChange={(value) => updateField('close_to_busy_road', parseInt(value))}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Yes', value: '1' },
          { label: 'No', value: '2' },
        ]}
        required
      />

      <Select
        label="Close to high voltage power lines?"
        name="close_to_high_voltage_lines"
        value={formData.close_to_high_voltage_lines || ''}
        onChange={(value) => updateField('close_to_high_voltage_lines', parseInt(value))}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Yes', value: '1' },
          { label: 'No', value: '2' },
        ]}
        required
      />

      <Select
        label="Is the property sloped?"
        name="property_sloped"
        value={formData.property_sloped || ''}
        onChange={(value) => updateField('property_sloped', parseInt(value))}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Yes', value: '1' },
          { label: 'No', value: '2' },
        ]}
        required
      />

      <Textarea
        label="What other external issues, if any, could impact the sale price of the house?"
        name="other_external_issues"
        value={formData.other_external_issues || ''}
        onChange={(value) => updateField('other_external_issues', value)}
        placeholder="(e.g., nearby landfill, railroad tracks, etc.)"
        rows={4}
      />
    </div>
  );
}
